import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
/* Layout */
import Layout from '@/layout'
export const
    routes = [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            component: () => import('@/views/home/index.vue')
        },
        {
            path: '/filePreview',
            component: () => import('@/views/FilePreview/index.vue')
        },
        {
            path: '/news-updates',
            component: Layout,
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/news-updates/list.vue'),
                    name: 'GenEdit',
                    meta: { title: '新闻动态', activeMenu: '/tool/gen' }
                },
                {
                    path: 'details',
                    component: () => import('@/views/news-updates/details.vue'),
                    name: 'GenEdit',
                    meta: { title: '新闻动态', activeMenu: '/tool/gen' }
                },
            ]
        },
        {
            path: '/notice-explanation',
            component: Layout,
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/notice-explanation/list.vue'),
                    name: 'GenEdit',
                    meta: { title: '通知说明', activeMenu: '/tool/gen' }
                },
                {
                    path: 'details',
                    component: () => import('@/views/notice-explanation/details.vue'),
                    name: 'GenEdit',
                    meta: { title: '通知说明', activeMenu: '/tool/gen' }
                },
            ]
        },
        {
            path: '/policies-regulations',
            component: Layout,
            children: [
                {
                    path: 'policy-document',
                    component: () => import('@/views/policies-regulations/policy-document.vue'),
                    name: 'GenEdit',
                    meta: { title: '政策文件', activeMenu: '/tool/gen' }
                },
                {
                    path: 'laws-regulations',
                    component: () => import('@/views/policies-regulations/laws-regulations.vue'),
                    name: 'GenEdit',
                    meta: { title: '法律法规', activeMenu: '/tool/gen' }
                },
            ]
        },
        {
            path: '/news',
            component: Layout,
            children: [
                {
                    path: 'branchIntroduction',
                    component: () => import('@/views/news/branchIntroduction.vue'),
                    name: 'GenEdit',
                    meta: { title: '关于分会', activeMenu: '/tool/gen' }
                },
                {
                    path: 'historicalMaterials',
                    component: () => import('@/views/news/historicalMaterials.vue'),
                    name: 'GenEdit',
                    meta: { title: '历史资料', activeMenu: '/tool/gen' }
                },
                {
                    path: 'boardmember',
                    component: () => import('@/views/news/boardmember.vue'),
                    name: 'GenEdit',
                    meta: { title: '分会负责人', activeMenu: '/tool/gen' }
                },
                {
                    path: 'membershipInstructions',
                    component: () => import('@/views/news/membershipInstructions.vue'),
                    name: 'GenEdit',
                    meta: { title: '入会说明', activeMenu: '/tool/gen' }
                },
                {
                    path: 'memberDetail',
                    component: () => import('@/views/news/memberDetail.vue'),
                    name: 'MemberDetail',
                    meta: { title: '分会负责人', activeMenu: '/tool/gen' }
                }
            ]
        },
        {
            path: '/talent-training',
            component: Layout,
            children: [
                {
                    path: 'riskManager',
                    component: () => import('@/views/talent-training/riskManager.vue'),
                    name: 'GenEdit',
                    meta: { title: '风险管理师', activeMenu: '/tool/gen' }
                },
                {
                    path: 'riskAssessor',
                    component: () => import('@/views/talent-training/riskAssessor.vue'),
                    name: 'GenEdit',
                    meta: { title: '风险评估师', activeMenu: '/tool/gen' }
                },
                {
                    path: 'publicRiskManager',
                    component: () => import('@/views/talent-training/publicRiskManager.vue'),
                    name: 'GenEdit',
                    meta: { title: '公共风险管理师', activeMenu: '/tool/gen' }
                },
            ]
        },

        {
            path: '/about',
            component: () => import('@/views/about/index.vue')
        },
        {
            path: '/certificateInquiry',
            component: () => import('@/views/certificateInquiry/index.vue')
        }
    ]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
})
